var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icone/Recherche",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#F20D0D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3,13.7 C0.9,12.3 0,10.3 0,8 C0,5.9 0.8,3.9 2.3,2.3 C3.8,0.8 5.8,-4.97379915e-14 8,-4.97379915e-14 L8,-4.97379915e-14 L8,-4.97379915e-14 C10.1,-4.97379915e-14 12.1,0.8 13.7,2.3 C15.3,3.8 16,5.8 16,8 C16,12.4 12.4,16 8,16 C5.7,16.1 3.7,15.2 2.3,13.7 Z M12.9,3.1 C11.6,1.8 9.8,1 8,1 L8,1 C6.1,1 4.4,1.7 3.1,3.1 C1.8,4.4 1,6.2 1,8.1 C1,12 4.1,15.1 8,15.1 C11.9,15.1 15,12 15,8.1 C14.9,6.2 14.2,4.4 12.9,3.1 Z",
    id: "Shape",
    transform: "translate(8.000000, 8.003775) rotate(-360.000000) translate(-8.000000, -8.003775) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0987283,18.3525037 C15.0987283,18.2191703 15.0987283,16.385837 15.0987283,12.8525037 C15.0987283,12.5525037 15.2987283,12.3525037 15.5987283,12.3525037 C15.8987283,12.3525037 16.0987283,12.5525037 16.0987283,12.8525037 C16.0987283,16.3191703 16.0987283,18.1525037 16.0987283,18.3525037 C16.0987283,18.6525037 15.8987283,18.8525037 15.5987283,18.8525037 C15.2987283,18.8525037 15.0987283,18.5525037 15.0987283,18.3525037 Z",
    id: "Path",
    transform: "translate(15.598728, 15.602504) rotate(-225.000000) translate(-15.598728, -15.602504) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/Loupe.2079bb5789214fa6eb9dc4f22209b599.svg";
export { ForwardRef as ReactComponent };